import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { lastValueFrom, map } from 'rxjs';
import {
  FinancialControllerService,
  PaymentResponseMessageType
} from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';
import { Role, roleAsObject } from 'src/app/models';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-payment-response-message-type',
  templateUrl: './payment-response-message-type.component.html',
  styleUrl: './payment-response-message-type.component.scss'
})
export class PaymentResponseMessageTypeComponent implements OnInit {
  permission = false;
  cols = [
    new TableColumn.Builder()
      .setHeader('Ícone')
      .setField('iconURL')
      .setType('image')
      .setRouterLink('/subscription-settings/payment-response-message-type/')
      .setRouterLinkFieldName('paymentResponseMessageTypeId')
      .setStyleClass('iconCol')
      .setFilter(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('Id')
      .setField('paymentResponseMessageTypeId')
      .setType('number')
      .setRouterLink('/subscription-settings/payment-response-message-type/')
      .setRouterLinkFieldName('paymentResponseMessageTypeId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Tipo')
      .setField('typeContent')
      .setRouterLink('/subscription-settings/payment-response-message-type/')
      .setRouterLinkFieldName('paymentResponseMessageTypeId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Descrição')
      .setField('messageContent')
      .setCondition('contains')
      .build()
  ];
  types: PaymentResponseMessageType[];

  constructor(
    private title: Title,
    public financialService: FinancialControllerService,
    private permissionsService: NgxPermissionsService
  ) {
    this.title.setTitle('Respostas de Cobranças');
  }

  async ngOnInit(): Promise<void> {
    LoaderService.showLoader();
    this.permission = await this.permissionsService.hasPermission([
      roleAsObject(Role.Full_Administrator).enumValue
    ]);
    await this.findPage();
    LoaderService.showLoader(false);
  }

  async findPage() {
    try {
      this.types = await lastValueFrom(
        this.financialService
          .findAllPaymentResponseMessageTypes()
          .pipe(map((data) => data.result))
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }
}
